export default __webpack_public_path__ + "static/media/Time_02.1e50d19f.png";